var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dots-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50176 9.73164C9.90562 9.73164 10.233 9.40425 10.233 9.00039C10.233 8.59653 9.90562 8.26914 9.50176 8.26914C9.0979 8.26914 8.77051 8.59653 8.77051 9.00039C8.77051 9.40425 9.0979 9.73164 9.50176 9.73164Z",
    fill: "#091647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50176 4.61289C9.90562 4.61289 10.233 4.2855 10.233 3.88164C10.233 3.47778 9.90562 3.15039 9.50176 3.15039C9.0979 3.15039 8.77051 3.47778 8.77051 3.88164C8.77051 4.2855 9.0979 4.61289 9.50176 4.61289Z",
    fill: "#091647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50176 14.8504C9.90562 14.8504 10.233 14.523 10.233 14.1191C10.233 13.7153 9.90562 13.3879 9.50176 13.3879C9.0979 13.3879 8.77051 13.7153 8.77051 14.1191C8.77051 14.523 9.0979 14.8504 9.50176 14.8504Z",
    fill: "#091647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50176 9.73164C9.90562 9.73164 10.233 9.40425 10.233 9.00039C10.233 8.59653 9.90562 8.26914 9.50176 8.26914C9.0979 8.26914 8.77051 8.59653 8.77051 9.00039C8.77051 9.40425 9.0979 9.73164 9.50176 9.73164Z",
    stroke: "#091647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50176 4.61289C9.90562 4.61289 10.233 4.2855 10.233 3.88164C10.233 3.47778 9.90562 3.15039 9.50176 3.15039C9.0979 3.15039 8.77051 3.47778 8.77051 3.88164C8.77051 4.2855 9.0979 4.61289 9.50176 4.61289Z",
    stroke: "#091647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50176 14.8504C9.90562 14.8504 10.233 14.523 10.233 14.1191C10.233 13.7153 9.90562 13.3879 9.50176 13.3879C9.0979 13.3879 8.77051 13.7153 8.77051 14.1191C8.77051 14.523 9.0979 14.8504 9.50176 14.8504Z",
    stroke: "#091647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.ad5489a91f4bc85b5244883dc591ae79.svg";
export { ForwardRef as ReactComponent };